import React, {useEffect, useRef, useState} from 'react';
import {
  calculateSumOfEachRowSadan,
  calculateTotalSum,
  deleteRowHandlerSadan,
  updateTableCellHandlerSadan
} from "../SellFactorSdanaShop/SellFactorFunctionsSadan";
import tableCalc from "../../utils/tableCalc";
import {ReactTabulator} from "react-tabulator";
import tabulatorTableOptions from "../../utils/TabulatorTableOptions";
import {formatToPersianAddComma, parseToEnRemoveComma} from "../../utils/CommaSeparator";
import NewTabulator from "../NewTabulator/NewTabulator";
import numeric from "../../utils/NumericFunction";
import utilsFunction from "../../utils/utilsFunction";

const BuyReturnTableSadan = ({sendData, setSendData, initialData, componentData, setComponentData,}) => {


  const [reload, setReload] = useState(false)
  useEffect(() => {
    setSendData({tableData: calculateSumOfEachRowSadan(sendData.tableData)})
  }, [reload])


  const [sum, setSum] = useState(0);
  useEffect(() => {
    const newSum = isNaN(calculateTotalSum(sendData)) ? 0 : calculateTotalSum(sendData)
    setSum(newSum)
  }, [sendData])

  const tableColumns = [
    {
      title: "حذف", headerSort: false, formatter: "buttonCross", // width: 60,
      style: {display: 'flex', justifyContent: 'center', alignItems: 'center'},
      maxWidth: 100, headerHozAlign: "center", cellClick: function (e, cell) {
        console.log("حذف حذف حذف");
        const productId = cell.getData().productId;
        const storeId = cell.getData().storeId;
        const type = cell.getData().type;
        const tableData = deleteRowHandlerSadan(sendData.tableData, productId, storeId, type);
        setSendData({tableData});
        setReload(!reload)
      },
    },
    {
      title: "کد کالا", field: 'productId', visible: false,
      style: {display: 'flex', justifyContent: 'center', alignItems: 'center'},
    },
    {title: "نام کالا", field: 'productName',},
    {
      title: "گروه کالا", field: 'productGroup',
      style: {display: 'flex', justifyContent: 'center', alignItems: 'center'},
    },


    {title: " کد انبار", field: "storeId", visible: false,},
    {title: "انبار", field: "storeName", visible: true,},
    {
      title: "قیمت", field: 'price', editor: "number",
      formatter: tableCalc.separateNumbers,
      editorParams: {
        min: 1, step: 1,
      },
      cellEdited: function (e, cell) {
        let value = e.target.value
        if (value === "") {
          value = "0"
        }
        value = parseToEnRemoveComma(value);

        const productId = cell.getData().productId;
        const storeId = cell.getData().storeId;
        const tableData = updateTableCellHandlerSadan(sendData.tableData, productId, storeId, "price", value);
        setSendData({tableData})
        setReload(!reload)

      }
    },
    {
      title: "وزن", field: 'weight', editor: "number",
      formatter: tableCalc.persianDigits,

      bottomCalc: tableCalc.sum,
      cellEdited: function (e, cell) {
        // const value = parseToEnRemoveComma(e.target.value);
debugger
        let value = (e.target.value);
        if (value === "") {
          value = "0"
        }
        value = numeric.p2e(value)

        value = utilsFunction.LimitDotAndThreeCharsAfterDot(value)
        const productId = cell.getData().productId;
        const storeId = cell.getData().storeId;
        const type = cell.getData().type;
        const tableData = updateTableCellHandlerSadan(sendData.tableData, productId, storeId, "weight", value,type);
        setSendData({tableData})
        setReload(!reload)
      }
    },
    {
      title: "جمع کل", field: "total", bottomCalc: tableCalc.sum,
      style: {display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden'},
    },

    {title: "  آدی موجودی", field: "inventoryId", visible: false,},
    {title: "آدی جزء", field: "particleFactorId", visible: false,},
    {field: "recordId", visible: false,},


  ];


  return (
    <div className="separate-factor__newSellComponent"
      // ref={seperateFac}
    >
      <NewTabulator
        columns={tableColumns}
        data={sendData.tableData}
        options={tabulatorTableOptions.tableOptions}
        style={{height: "70vh"}}
        className={"header__color__F1F1F1"}


      />

      {/*<ReactTabulator*/}
      {/*  ref={tableRef}*/}
      {/*  columns={tableColumns}*/}
      {/*  // data={dataEdit.main !== undefined ? dataEdit.particle.data : [] }*/}
      {/*  data={sendData.tableData}*/}
      {/*  // dataChanged={(newData) => console.log("dataChanged", newData)}*/}
      {/*  options={tabulatorTableOptions.tableOptions}*/}
      {/*  style={{height: "70vh"}}*/}

      {/*/>*/}
      <div> جمع کل : {formatToPersianAddComma(sum)}</div>

    </div>
  );
};

export default BuyReturnTableSadan;
